




























import { Vue, Component } from "vue-property-decorator";
import { Form, Calendar, List, PullRefresh,Tab,Tabs } from "vant";
import { TaskFormEntity } from "../../model/Btrip";
import btripServcice from "@/service/btripServcice";
import cardList from "@/views/btrip/components/cardList.vue";
import { removeKeepalive } from "@/views/modules/keepUtils";
@Component({
  name: "applicationList",
  components: {
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Tab.name]: Tab,
    [Tabs.name]:Tabs,
    cardList,
  },
})
export default class extends Vue {
  delID = "";
  tags = {
    CreateByName: "",
    TaskName: "",
    TaskID: "",
    PageNo: "",
    PageSize: "",
  };
  tagsNumber = {
    pendingtags: "",
    launchtags: "",
    processedtags: "",
  };
  pageStatus = "";
  TaskForm: TaskFormEntity[][] = [];
  actived() {
    console.log("加载了actived");
  }
  mounted() {
    this.PendingTags();
    this.LaunchTags();
    this.ProcessedTags();
    console.log("加载了mounted");
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  TagsReset() {
    this.tags.CreateByName = "";
    this.tags.TaskName = "";
    this.tags.TaskID = "";
    (this.tags.PageNo = ""), (this.tags.PageSize = "");
  }
  PendingTags() {
    this.TagsReset();
    this.tags.CreateByName = String(this.profile.UserName);
    this.tags.PageSize = "999";
    this.tags.PageNo = "1";
    btripServcice.getTasklist(this.tags).then((json: any) => {
      if (json.isSucc) {
        const arr = json.result.entities.filter((item: any) => {
          if (item.TaskStatus !== "审批拒绝" && item.TaskStatus !== "审批通过") {
            return item;
          }
        });
        this.tagsNumber.pendingtags = arr.length;
      }
    });
  }
  LaunchTags() {
    this.TagsReset();
    this.tags.TaskName = String(this.profile.UserName);
    btripServcice.getTasklist(this.tags).then((json: any) => {
      if (json.isSucc) {
        this.tagsNumber.launchtags = json.result.RecordCount + 1;
      }
    });
  }
  ProcessedTags() {
    this.TagsReset();
    this.tags.CreateByName = String(this.profile.UserName);
    this.tags.PageSize = "999";
    this.tags.PageNo = "1";
    btripServcice.getTasklist(this.tags).then((json: any) => {
      if (json.isSucc) {
        for (let i = 0; i < json.result.entities.length; i++) {
          if (json.result.entities[i].TaskStatus == "审批拒绝" || json.result.entities[i].TaskStatus == "审批通过") {
            this.TaskForm.push(json.result.entities[i]);
          }
        }
        this.tagsNumber.processedtags = String(this.TaskForm.length);
      }
    });
  }
  destroyed() {
    removeKeepalive(this.$route.path);
  }
}
